// extracted by mini-css-extract-plugin
export var backdropBlur = "_hc-0";
export var contentCard = "_hc-5";
export var frame = "_hc-2";
export var image = "_hc-4";
export var imagePane = "_hc-3";
export var modal = "_hc-1";